import { CircularProgress, DialogActions, DialogContent } from '@mui/material';
import classNames from 'classnames';
import { memo, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';

import { IcaoIataCode, useQueryGetGetAirlines } from '../../../../../../../../backend';
import { useBoolean } from '../../../../../../../../hooks/useBoolean';
import { errorToastConfig } from '../../../../../../../../utils/utils';
import { CustomSearch } from '../../../../../../../navigation/Search/CustomSearch';
import {
    StyledBox,
    StyledCancelButton,
    StyledDialog,
    StyledDialogTitle,
    StyledOpenButton,
    StyledSaveButton,
} from './DcsSelection.style';
import { TransfertList } from './TransfertList';

export const DcsSelection = memo(function DscSelection({
    dcs,
    handleDcsChange,
    modified,
}: {
    dcs: IcaoIataCode[];
    handleDcsChange: (e: IcaoIataCode[]) => void;
    modified: boolean | undefined;
}) {
    const {
        data: airlines,
        isLoading,
        isSuccess,
    } = useQueryGetGetAirlines({
        onError: () => {
            toast(<FormattedMessage id={'resourcesForm.error.default'} />, errorToastConfig);
        },
        cacheTime: Infinity,
    });

    const { value: opened, setTrue: open, setFalse: close } = useBoolean(false);

    return (
        <div>
            <StyledOpenButton
                onClick={isSuccess ? open : undefined}
                className={classNames({
                    modified,
                })}
            >
                {isLoading ? <CircularProgress sx={{ width: 12 }} /> : dcs.length}
            </StyledOpenButton>
            {opened && airlines.length > 0 && (
                <AirlinesDialog handleClose={close} handleDcsChange={handleDcsChange} dcs={dcs} airlines={airlines} />
            )}
        </div>
    );
});

const AirlinesDialog = ({
    handleClose,
    handleDcsChange,
    dcs,
    airlines,
}: {
    handleClose: () => void;
    handleDcsChange: (e: IcaoIataCode[]) => void;
    dcs: IcaoIataCode[];
    airlines: IcaoIataCode[];
}) => {
    const [search, setSearch] = useState<string>('');
    const [selection, setSelection] = useState<number[]>(
        dcs.map(item => airlines.findIndex(airlineItem => airlineItem.id === item.id)),
    );
    const handleSave = useCallback(() => {
        handleDcsChange(selection.map(selectedIndex => airlines[selectedIndex]));
        handleClose();
    }, [handleClose, airlines, handleDcsChange, selection]);
    return (
        <StyledDialog onClose={handleClose} open={true}>
            <StyledDialogTitle>
                <FormattedMessage id={'Resource.dsc.select'} />
                <StyledBox>
                    <CustomSearch search={search} setSearch={setSearch} />
                </StyledBox>
            </StyledDialogTitle>
            <DialogContent>
                <TransfertList airlines={airlines} search={search} selection={selection} setSelection={setSelection} />
            </DialogContent>
            <DialogActions>
                <StyledCancelButton onClick={handleClose}>
                    <FormattedMessage id={'form.button.cancel'} />
                </StyledCancelButton>
                <StyledSaveButton variant="contained" onClick={handleSave}>
                    <FormattedMessage id={'form.button.confirm'} />
                </StyledSaveButton>
            </DialogActions>
        </StyledDialog>
    );
};
